import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import type { MenuProps } from "antd";
import {
  Button,
  Dropdown,
  Skeleton,
  Row,
  Col,
  Progress,
  Avatar,
  Empty,
} from "antd";
import { getClass } from "../../../../../api/class/class";
import { RootState } from "../../../../../store/store";
import { useSelector } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { openNotificationWithIcon } from "../../../../../utils/helper";
import { getCurriculumAssignmentForTeacher } from "../../../../../api/curriculum/curriculum";
import Assigncurriculum from "./assigncurriculum/assigncurriculum";
import Curriculumloader from "../../../../../components/dashboardpages/loaders/curriculumloader/curriculumloader";
import Invitemember from "./invitemember/invitemember";
import Editclass from "../editclass/editclass";
import Deleteclass from "./deleteclass/deleteclass";

const percentage = 0;

const Teacherclass = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { classId } = useParams();

  const [showDeleteClass, setShowDeleteClass] = useState(false);
  const [showEditClass, setShowEditClass] = useState(false);
  const [memberInvited, setMemberInvited] = useState<"student" | "teacher">(
    "student"
  );
  const [showInviteMember, setShowInviteMember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [classDetails, setClassDetails] = useState<any>({
    students: [],
    subTeachers: [],
  });
  const [loadingAssignment, setLoadingAssignment] = useState(true);
  const [classCurriculumAssignment, setClassCurriculumAssignment] = useState(
    []
  );
  const [showAssignCurriculum, setShowAssignCurriculum] = useState(false);

  useEffect(() => {
    navigate(`${pathname}`, {
      state: {
        pageName: "Class",
      },
    });

    // eslint-disable-next-line
  }, []);

  const closeShowDelete = () => {
    setShowDeleteClass(false);
  };

  const closeShowEditClass = (reload?: boolean) => {
    setShowEditClass(false);
    if (reload) {
      fetchClass();
    }
  };

  const closeShowInviteMember = (reload?: boolean) => {
    setShowInviteMember(false);
    if (reload) {
      fetchClass();
    }
  };

  const closeShowAssignCurriculum = (reload?: boolean) => {
    setShowAssignCurriculum(false);
    if (reload) {
      fetchClassAssignment();
    }
  };

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  const { user } = state;

  const fetchClassAssignment = async () => {
    try {
      setLoadingAssignment(true);
      const res = await getCurriculumAssignmentForTeacher(classId || "");
      const { data } = res?.data;
      setClassCurriculumAssignment(data);
      setLoadingAssignment(false);
    } catch (error: any) {
      setLoadingAssignment(false);
      if (error?.response) {
        openNotificationWithIcon(
          "error",
          "Class Curriculum Assignment",
          `${error?.response?.data?.message || "Something went wrong"}`
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Class Curriculum Assignment",
          "Something went wrong"
        );
      }
    }
  };

  const fetchClass = async () => {
    try {
      setLoading(true);
      const res = await getClass(classId || "");
      const { data } = res?.data;
      setClassDetails(data);
      setLoading(false);
      fetchClassAssignment();
    } catch (error: any) {
      setLoading(false);
      if (error?.response) {
        openNotificationWithIcon(
          "error",
          "Get Class",
          `${error?.response?.data?.message || "Something went wrong"}`
        );
      } else {
        openNotificationWithIcon("error", "Get Class", "Something went wrong");
      }
      navigate(`/teacher/dashboard/classes`);
    }
  };

  useEffect(() => {
    fetchClass();

    // eslint-disable-next-line
  }, []);

  const items: MenuProps["items"] = [
    {
      key: `class-edit-open`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`${pathname}`}
          onClick={(e) => {
            e.preventDefault();
            if (!loading) {
              setShowEditClass(true);
            }
          }}
        >
          Edit
        </a>
      ),
    },
    {
      key: `class-add-teacher`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`${pathname}`}
          onClick={(e) => {
            e.preventDefault();
            if (!loading) {
              setMemberInvited("teacher");
              setShowInviteMember(true);
            }
          }}
        >
          Add Teacher
        </a>
      ),
    },
    {
      key: `class-add-student`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`${pathname}`}
          onClick={(e) => {
            e.preventDefault();
            if (!loading) {
              setMemberInvited("student");
              setShowInviteMember(true);
            }
          }}
        >
          Add Student
        </a>
      ),
    },
    {
      key: `class-delete-class`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`${pathname}`}
          onClick={(e) => {
            e.preventDefault();
            if (!loading) {
              setShowDeleteClass(true);
            }
          }}
          style={{
            color: "red",
          }}
        >
          Delete
        </a>
      ),
    },
  ];

  return (
    <div className="h-screen pr-10 mt-4">
      <div className="flex items-center justify-between">
        <p className="text-lg font-[900] capitalize text-appcolorpurplefaintone">
          {loading ? (
            <Skeleton.Button
              active={true}
              size={"large"}
              shape={"square"}
              block={true}
              style={{
                height: "2rem",
                width: "6rem",
              }}
            />
          ) : (
            classDetails?.name
          )}
        </p>

        <div className="flex items-center">
          <div className="mr-[1.8rem]">
            <Dropdown menu={{ items }} placement="bottomRight">
              <img
                src="/img/vectors/more.svg"
                alt="more"
                className="w-8 h-5 cursor-pointer"
              />
            </Dropdown>
          </div>
          <div className="mr-[1.8rem] flex">
            <img src="/img/vectors/classcardmessage.svg" alt="message" />
            <p className="pl-1 text-sm font-semibold text-appcolorfaintpurpletwo">
              0
            </p>
          </div>
          <Button
            className="custom-primary-two-btn extra-smaller-padding"
            onClick={() => {
              setMemberInvited("student");
              setShowInviteMember(true);
            }}
          >
            + Add Student
          </Button>
        </div>
      </div>

      <div className="mt-[2.3rem]">
        <Row gutter={32}>
          <Col lg={14} md={24} xs={24}>
            <div className="mb-10 max-h-[90vh] min-h-[90vh] overflow-auto pb-10 pr-4">
              <div className="flex items-center">
                {loading ? (
                  <Skeleton.Button
                    active={true}
                    size={"large"}
                    shape={"square"}
                    block={true}
                    style={{
                      height: "2rem",
                      width: "100%",
                      marginBottom: "0.3rem",
                    }}
                  />
                ) : (
                  <>
                    <p className="mr-1 text-base font-bold text-appcolorgrey">
                      Class Code:
                    </p>

                    <div className="flex items-center justify-between flex-1">
                      <p className="font-bold text-appcolorgrey opacity-[0.5]">
                        {classDetails?.code}
                      </p>

                      <CopyToClipboard
                        text={classDetails?.code}
                        onCopy={() => {
                          openNotificationWithIcon(
                            "info",
                            "Copy Code",
                            "Class code copied to clipboard"
                          );
                        }}
                      >
                        <img
                          src="/img/vectors/copyclass.svg"
                          alt="copyclass"
                          className="cursor-pointer"
                        />
                      </CopyToClipboard>
                    </div>
                  </>
                )}
              </div>

              {/* <div className="flex items-center mt-4">
								<p className="mr-1 text-base font-medium text-appcolorgrey">Class Link:</p>
								
								<div className="flex items-center justify-between flex-1">
									<p className="text-appcolorgrey ">Share Link</p>
									<img src="/img/vectors/classshare.svg" alt="copyclass" className="cursor-pointer" />
								</div>
							</div> */}

              <div className="relative mt-4 border-t-[0.3px] border-appcolorpurplefaintone pl-2 pt-4">
                {loading ? (
                  <Skeleton.Button
                    active={true}
                    size={"large"}
                    shape={"square"}
                    block={true}
                    style={{
                      height: "5rem",
                      width: "100%",
                      marginBottom: "0.3rem",
                    }}
                  />
                ) : (
                  <div className="relative flex mt-2">
                    <div className="flex items-center">
                      <div className="relative flex justify-center">
                        <div className="absolute top-[-0.3rem] mx-auto">
                          <Progress
                            type="circle"
                            percent={percentage}
                            trailColor="#d8edda"
                            strokeColor="#3da344"
                            showInfo={false}
                            size={63}
                          />
                        </div>

                        <div className="relative flex items-center justify-center rounded-full bg-appcolorwhite p-[0.1rem]">
                          <img
                            src="/img/vectors/python.svg"
                            alt="python"
                            className="h-[3rem] w-[3rem]"
                          />
                        </div>
                      </div>

                      <p className="ml-4 mt-3 text-xl font-[900]  text-appcolorgreenfour">
                        0%
                      </p>
                    </div>

                    <div className="absolute w-full mr-6 pl-28">
                      <div className="flex justify-between mt-3 item-center ">
                        <div className="flex items-center">
                          <img
                            src="/img/vectors/purpleunit.svg"
                            alt="users"
                            className="w-5 h-5"
                          />

                          <div className="flex items-center">
                            <p className="pr-1 text-sm font-extrabold text-appcolorfaintpurpletwo">
                              {classDetails?.students?.length}
                            </p>
                            <p className="text-xs font-semibold text-appcolorfaintpurplethree">
                              lessons
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center">
                          <img
                            src="/img/vectors/classcardtime.svg"
                            alt="users"
                            className="w-5 h-5"
                          />

                          <div className="flex items-center">
                            <p className="pr-1 text-sm font-extrabold text-appcolorfaintpurpletwo">
                              20
                            </p>
                            <p className="text-xs font-semibold text-appcolorfaintpurplethree">
                              min/class
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="flex justify-between mt-3 item-center ">
                        <div className="flex items-center">
                          <img
                            src="/img/vectors/purpleunit.svg"
                            alt="users"
                            className="w-5 h-5"
                          />

                          <div className="flex items-center">
                            <p className="pr-1 text-sm font-extrabold text-appcolorfaintpurpletwo">
                              {10}
                            </p>
                            <p className="text-xs font-semibold text-appcolorfaintpurplethree">
                              assignments
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center">
                          <img
                            src="/img/vectors/classcarduser.svg"
                            alt="users"
                            className="w-5 h-5"
                          />

                          <div className="flex items-center">
                            <p className="pr-1 text-sm font-extrabold text-appcolorfaintpurpletwo">
                              {classDetails?.students.length}
                            </p>
                            <p className="text-xs font-semibold text-appcolorfaintpurplethree">
                              students
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="mt-12">
                  <div className="flex items-center justify-between mb-4">
                    <p className="text-xl font-bold capitalize text-appcolorblackfainteleven">
                      Curriculum Assigned
                    </p>

                    <Button
                      className="custom-secondary-btn extra-smaller-padding"
                      onClick={() => {
                        setShowAssignCurriculum(true);
                      }}
                    >
                      + Assign Curriculum
                    </Button>
                  </div>

                  <div>
                    {loadingAssignment || loading ? (
                      <>
                        {[1, 23, 4].map((item) => (
                          <Curriculumloader key={`curriculum-loader-${item}`} />
                        ))}
                      </>
                    ) : (
                      <>
                        {classCurriculumAssignment.length === 0 ? (
                          <div className="flex justify-center w-full">
                            <Empty
                              description={`You currently don't have any assigned curriculum in this class.`}
                            />
                          </div>
                        ) : (
                          classCurriculumAssignment.map((item: any) => (
                            <div className="p-6 mb-3 rounded-3xl bg-appcolorpurplefainthree">
                              <p className="text-base font-[900] capitalize text-appcolorpurplefaintone">
                                {item?.curriculum?.name}
                              </p>

                              <div className="mt-4 flex w-full border-t-[0.3px] border-appcolorpurplefaintone pt-4">
                                <Row gutter={8} className="w-full">
                                  <Col xs={24} md={24} lg={12}>
                                    {
                                      <div className="flex items-center mb-2">
                                        <img
                                          src="/img/vectors/purpletime.svg"
                                          alt="users"
                                          className="w-5 h-5 mr-1"
                                        />

                                        <div className="flex items-center">
                                          <p className="pr-1 text-base font-extrabold text-appcolorpurplefaintone">
                                            {item?.curriculum?.duration}
                                          </p>
                                          <p className="text-sm text-appcolorpurplefaintone">
                                            {item?.curriculum?.durationUnit}
                                            {item?.curriculum?.duration > 1
                                              ? "s"
                                              : ""}
                                          </p>
                                        </div>
                                      </div>
                                    }
                                  </Col>

                                  <Col xs={24} md={24} lg={12}>
                                    {
                                      <div className="flex items-center mb-2">
                                        <img
                                          src="/img/vectors/purpleminmod.svg"
                                          alt="users"
                                          className="w-5 h-5 mr-1"
                                        />

                                        <div className="flex items-center">
                                          <p className="pr-1 text-base font-extrabold text-appcolorpurplefaintone">
                                            2
                                          </p>
                                          <p className="text-sm text-appcolorpurplefaintone">
                                            min/module
                                          </p>
                                        </div>
                                      </div>
                                    }
                                  </Col>

                                  <Col xs={24} md={24} lg={12}>
                                    {
                                      <div className="flex items-center mb-2">
                                        <img
                                          src="/img/vectors/purpledocument.svg"
                                          alt="users"
                                          className="w-5 h-5 mr-1"
                                        />

                                        <div className="flex items-center">
                                          <p className="pr-1 text-base font-extrabold text-appcolorpurplefaintone">
                                            2
                                          </p>
                                          <p className="text-sm text-appcolorpurplefaintone">
                                            assignments
                                          </p>
                                        </div>
                                      </div>
                                    }
                                  </Col>

                                  <Col xs={24} md={24} lg={12}>
                                    {
                                      <div className="flex items-center">
                                        <img
                                          src="/img/vectors/purpleplans.svg"
                                          alt="users"
                                          className="w-5 h-5 mr-1"
                                        />
                                        <div className="flex items-center">
                                          <p className="pr-1 text-base font-extrabold text-appcolorpurplefaintone">
                                            {item?.curriculum?.modulesCount}
                                          </p>
                                          <p className="text-sm text-appcolorpurplefaintone">
                                            lesson plan
                                            {item?.curriculum?.modulesCount > 1
                                              ? "s"
                                              : ""}
                                          </p>
                                        </div>
                                      </div>
                                    }
                                  </Col>

                                  <Col xs={24} md={24} lg={12}>
                                    {
                                      <div className="mt-[1.4rem] flex items-center">
                                        <div className="custom-piped custom-piped-curicard pr-[0.6rem]">
                                          {user?._id ===
                                          item?.curriculum?.createdBy ? (
                                            <>
                                              <img
                                                src={`${
                                                  user?.userAvatarURL ===
                                                  undefined
                                                    ? "/img/vectors/usertag.svg"
                                                    : user?.userAvatarURL === ""
                                                    ? "/img/vectors/usertag.svg"
                                                    : user?.userAvatarURL
                                                }`}
                                                alt="usertag"
                                                className="w-6 h-6 rounded-full"
                                              />
                                            </>
                                          ) : (
                                            <>
                                              <img
                                                src="/img/logo/cfhcircle.svg"
                                                alt="cfhcircle"
                                                className="w-6 h-6 border rounded-full border-appcolororangethree"
                                              />
                                            </>
                                          )}
                                        </div>

                                        <div className="ml-[0.6rem] flex flex-grow items-center justify-between">
                                          <div className="flex flex-col">
                                            <p className="text-xs text-appcolorpurplefaintone">
                                              Created by
                                            </p>
                                            <p className="text-base font-extrabold text-appcolorpurplefaintone">
                                              {user?._id ===
                                              item?.curriculum?.createdBy
                                                ? `${user.userName}`
                                                : "CFH"}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </Col>
                                  <Col xs={24} md={24} lg={12}>
                                    {
                                      <div className="mt-[1.4rem] flex flex-col">
                                        <p className="text-xs text-appcolorpurplefaintone">
                                          Assigned to
                                        </p>
                                        <div className="flex items-center">
                                          <img
                                            src="/img/vectors/curicullumusers.svg"
                                            alt="users"
                                            className="w-6 h-6"
                                          />
                                          <p className="pr-1 text-lg font-extrabold text-appcolorpurplefaintone">
                                            1
                                          </p>
                                          <p className="text-sm text-appcolorpurplefaintone">
                                            Classes
                                          </p>
                                        </div>
                                      </div>
                                    }
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          ))
                        )}
                      </>
                    )}
                  </div>
                </div>

                <div className="mt-12">
                  <div className="flex justify-between mb-4">
                    <p className="text-xl font-bold capitalize text-appcolorblackfainteleven">
                      Teachers
                    </p>

                    <Button
                      className="custom-secondary-btn extra-smaller-padding"
                      onClick={() => {
                        setMemberInvited("teacher");
                        setShowInviteMember(true);
                      }}
                    >
                      + Add Teacher
                    </Button>
                  </div>

                  <div>
                    {loading ? (
                      [1, 3, 4].map((item) => (
                        <Skeleton.Button
                          key={`loading-teachers-${item}`}
                          active={true}
                          size={"large"}
                          shape={"square"}
                          block={true}
                          style={{
                            height: "4rem",
                            width: "100%",
                            marginBottom: "1rem",
                          }}
                        />
                      ))
                    ) : (
                      <div>
                        <p className="flex items-center mb-3">
                          <img
                            src="/img/logo/cfhcircle.svg"
                            alt="cfhcircle"
                            className="w-8 h-8 pr-2"
                          />
                          <span>Me</span>
                        </p>

                        {classDetails?.subTeachers.map((item: any) => (
                          <p className="flex items-center mb-3">
                            <img
                              src={`${
                                item?.teacherId?.userAvatarURL === undefined
                                  ? "/img/vectors/usertag.svg"
                                  : item?.teacherId?.userAvatarURL === ""
                                  ? "/img/vectors/usertag.svg"
                                  : item?.teacherId?.userAvatarURL
                              }`}
                              alt="usertag"
                              className="w-8 h-8 pr-2"
                            />

                            <span>
                              {item?.teacherId?.firstName}{" "}
                              {item?.teacherId?.lastName}
                            </span>
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={10} md={24} xs={24}>
            <div>
              <p className="mb-2 text-xl font-bold capitalize text-appcolorblackfainteleven">
                Classroom Leaderboard
              </p>

              <p className="mb-2 text-base">
                See how students are doing in your class
              </p>

              <div>
                {loading ? (
                  <>
                    {[3, 4, 5].map((item) => (
                      <Skeleton.Button
                        key={`loading-students-${item}`}
                        active={true}
                        size={"large"}
                        shape={"square"}
                        block={true}
                        style={{
                          height: "4rem",
                          width: "100%",
                          marginBottom: "1rem",
                        }}
                      />
                    ))}
                  </>
                ) : (
                  <>
                    {classDetails?.students?.length === 0 ? (
                      <>
                        <p className="tex-base text-appcolorblackfainteleven">
                          Leaderboard data currently unavailable
                        </p>
                      </>
                    ) : (
                      classDetails?.students.map((item: any, index: number) => (
                        <div
                          key={`fpt-${item.id}`}
                          className={`mb-0 flex items-center justify-between p-4 hover:rounded-[10px] hover:bg-appcolororangefaint  `}
                        >
                          <div className="flex items-center">
                            <p className="mr-2 rounded-[7px] bg-appcolorpurplefour px-[0.6rem] py-[0.2rem] text-appcolorwhite">
                              {index + 1}
                            </p>

                            <div className="flex items-center">
                              <Avatar
                                src={`${
                                  item?.userAvatarURL === undefined
                                    ? "/img/vectors/userfemale.svg"
                                    : item?.userAvatarURL === ""
                                    ? "/img/vectors/userfemale.svg"
                                    : item?.userAvatarURL
                                }`}
                                style={{
                                  border: "2px solid #FBE0FF",
                                  borderRadius: "50%",
                                  width: "3rem",
                                  height: "3rem",
                                }}
                              />

                              <div className="ml-3">
                                <p className="mb-1 text-base font-semibold text-appcolorblack">
                                  {item.firstName}
                                </p>
                                <p className="text-base font-semibold  text-appcolorblack opacity-[0.5]">
                                  {item.lastName}
                                </p>
                              </div>
                            </div>
                          </div>
                          {/* <div className=''>
															<p className='mb-1 text-base font-semibold text-appcolorblack'>
																40000FP
															</p>
														</div> */}
                        </div>
                      ))
                    )}
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>

      {showAssignCurriculum ? (
        <Assigncurriculum
          open={showAssignCurriculum}
          closeModal={closeShowAssignCurriculum}
          students={classDetails?.students}
          classId={classId || ""}
        />
      ) : null}

      {showInviteMember ? (
        <Invitemember
          open={showInviteMember}
          closeModal={closeShowInviteMember}
          memberType={memberInvited}
          classCode={classDetails?.code}
          classId={classId || ""}
        />
      ) : null}

      {showEditClass ? (
        <Editclass
          open={showEditClass}
          closeModal={closeShowEditClass}
          language={classDetails?.languageId?.name}
          classId={classId || ""}
          classDetails={{
            name: classDetails?.name,
            description: classDetails?.description,
          }}
        />
      ) : null}

      {showDeleteClass ? (
        <Deleteclass
          open={showDeleteClass}
          closeModal={closeShowDelete}
          classId={classId || ""}
        />
      ) : null}
    </div>
  );
};

export default Teacherclass;
